/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import Viewer from 'components/Viewer'
import ViewerContainer from 'containers/Viewer'
import SumerianContainer from 'containers/Sumerian'
import ReportQueryContainer from 'containers/ReportQuery'
import { withProps } from 'recompose'

const addDisplay = withProps(origProps => ({
  Display: Viewer,
}))

const SumerianComposition = ReportQueryContainer(
  SumerianContainer(addDisplay(ViewerContainer))
)
export default SumerianComposition
